<template>
    <b-col>
        <ol class="quote-steps">
            <li
                v-for="(sidebarListLink, idx) in sidebarListLinks"
                :key="'sid-link-' + idx"
                v-bind:class="{
                    'steps-checked': step > idx + 1,
                    'steps-active': step == idx + 1
                }"
            >
                <router-link :to="getIfRouteNotDisabled(sidebarListLink)">{{
                    sidebarListLink.label
                }}</router-link>
            </li>
        </ol>
        <slot></slot>
    </b-col>
</template>

<script>
export default {
    props: ["step", "sidebarListLinks", "disabled"],
   
    methods: {
       getIfRouteNotDisabled(sidebarListLink){
           if(sidebarListLink.disabled){
               return "";
           }
           return sidebarListLink.routeTo;
           
       } 
    }
};
</script>
